import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="w-full min-h-[70vh] px-4 md:px-8 flex flex-col items-center justify-center text-center">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500">
        <i className="ri-film-line text-4xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
        404
      </h1>
      <p className="mt-3 text-base text-foreground-600">这个页面好像不在剧本里</p>
      <p className="mt-1.5 text-sm text-foreground-500">
        你访问的页面不存在或已被移除，不如去别处看看精彩的影视内容
      </p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          回到首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300/70 text-foreground-800 text-sm hover:border-accent-500/60 hover:text-accent-400 transition-colors whitespace-nowrap"
        >
          <i className="ri-movie-2-line"></i>
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}